import { AppState } from 'src/app/store/app.states';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Store, select } from '@ngrx/store';
import { FeatureToggleValue } from 'src/app/model/feature-toggle-value.model';
import { FeatureToggleLevel } from 'src/app/model/feature-toggle-level.model';
import { Observable } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { commonState_SystemConfig_AccountFeatureToggles, commonState_SystemConfig_LimitedServiceToggles } from 'src/app/store/common/common.selectors';
import { memberAccountDropdown_SelectedAccount } from '../components/member-account-dropdown/selectors';
import { DateHelper } from 'src/app/helper/dateHelper';

@Pipe({
  name: 'featureToggle',
})
export class FeatureTogglePipe implements PipeTransform {
  constructor(
    public store: Store<AppState>,
    protected _sanitizer: DomSanitizer
  ) {}

  dateHelper:DateHelper = new DateHelper();

  accountFeatureToggles$ = this.store.pipe(
    select(commonState_SystemConfig_AccountFeatureToggles)
  );
  selectedAccount$ = this.store.pipe(
    select(memberAccountDropdown_SelectedAccount)
  );
  limitedServiceEvents$ = this.store.pipe(
    select(commonState_SystemConfig_LimitedServiceToggles)
  );

  async transform(value: string): Promise<string> {
    var featureToggles = await this.getValue(this.accountFeatureToggles$);
    var selectedAccount = await this.getValue(this.selectedAccount$);
    var limitedServiceEvents = await this.getValue(this.limitedServiceEvents$);

    const date = this.dateHelper.convertToSydneyTime(new Date());

    const filteredLimitedServiceEvents = limitedServiceEvents.filter(x => (x.startDate && x.endDate && this.dateHelper.convertToSydneyTime(new Date(x.startDate)) <= date &&
      date <= this.dateHelper.convertToSydneyTime(new Date(x.endDate))) || !x.startDate && !x.endDate);

    if (!value) return FeatureToggleValue.available;

    // check if limited service event is on
    var limitedToggle = filteredLimitedServiceEvents.find(x => x.name === value);

    if (limitedToggle){
      return limitedToggle.value;
    }

    var globalFlag = featureToggles.find(
      (x) => x.level === FeatureToggleLevel.global && x.name === value
    );

    if (!globalFlag) {
      return FeatureToggleValue.hidden;
    }

    if (globalFlag.value !== FeatureToggleValue.available)
      return globalFlag.value;

    var accountFlag = featureToggles.find(
      (x) =>
        x.level === FeatureToggleLevel.accountClassification &&
        x.name === value &&
        Number(x.levelReference) === selectedAccount?.accountClassificationId
    );

    if (!accountFlag) {
      return FeatureToggleValue.hidden;
    }

    return accountFlag.value;
  }

  hasValue(value: any) {
    return value !== null && value !== undefined;
  }

  getValue<T>(observable: Observable<T>): Promise<T> {
    return observable.pipe(filter(this.hasValue), first()).toPromise();
  }
}
